module.exports = __webpack_public_path__ + "static/media/story-update.aa546054.svg";